import $ from "jquery";
import * as THREE from "three";
import {
  ChangeGlobalMorph,
  GetGroup,
  GetMesh,
  modelForExport,
  toggleBackWall,
  toggleLeftWall,
  toggleRightWall,
} from "../../../../../core/3d-configurator";
import {
  changeTextureTop,
  listenerChange,
} from "../../../../../core/customFunctions/customFunctions";
import {
  resetSpansActiveScreen,
  resetSpansActiveShades,
  setSpansScreen,
  spansScreen,
  setAllHotspotsVisibilityScreen
} from "../../../../../core/customFunctions/subSystemScreen";
import { state } from "../../../../../core/settings";
import { groups } from "../../../interface";
import "./interfaceGroupInputs.scss";
import { generateRangeHTML } from "./range/generateRange";
import { typePortalOption } from "../../../../portal/portals";
import {
  setAllHotspotsVisibility,
  spansHeaters,
} from "../../../../../core/customFunctions/subSystemHeaters";

export const colors = {
  "Textured Black": "#1C1C1C",
  "Textured White": "#f8f8f8",
  "Industrial Grey": "#B0B0B0",
  Charcoal: "#36454F",
  "C34 Bronze": "#3F1A00",
  "Anodized Bronze": "#6A5A3A",
  Expresso: "#3A2A1D",
  Gold: "#C5A052",
};

export function createGoldNoiseTexture() {
  const canvas = document.createElement('canvas');
  canvas.width = 1024;
  canvas.height = 1024;

  const ctx = canvas.getContext('2d');
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;

  // noise variation for gold
  for (let i = 0; i < data.length; i += 4) {
    const noise = (Math.random() - 0.5) * 30;
    const baseValue = 190 + noise;

    data[i] = Math.max(0, Math.min(255, baseValue + 10));     // R
    data[i + 1] = Math.max(0, Math.min(255, baseValue - 10)); // G
    data[i + 2] = Math.max(0, Math.min(255, baseValue - 50)); // B
    data[i + 3] = 255; // Alpha
  }

  ctx.putImageData(imageData, 0, 0);

  const texture = new THREE.CanvasTexture(canvas);
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.needsUpdate = true;

  return texture;
}

export const typesInputs = {
  radioModel: "radio-wall",
  selectButton: "select",
  range: "button",
  postSize: "post-size",
  colorsButton: "colorsButton",
  electronic: "electro",
  subSystem: "system",
  roofForLite: "liteRoof",
  roofTypes: "roofTypes",
};

export const typeSubSystem = {
  screen: "Screens",
  shades: "Shades",
};

export const subSystemConfig = {
  screens: {
    type: typeSubSystem.screen,
    image: "./public/img/screens.svg",
    label: "Screens"
  },
  shades: {
    type: typeSubSystem.shades,
    image: "./public/img/shades.svg",
    label: "Shades"
  }
};

export function updateTextParam(
  customSetting,
  context,
  electro = false,
  onlyText = false,
  subSystem = false
) {
  const text = [];
  let isCheckingHeater = false;

  if (!electro) {
    if (customSetting.backWall) text.push("Back Wall");
    if (customSetting.leftWall) text.push("Left Wall");
    if (customSetting.rightWall) text.push("Right Wall");
  } else if (subSystem) {
    customSetting.subSystem.forEach((option) => text.push(option));
  } else {
    customSetting.electro.forEach((option) => {
      if (!option.startsWith('heater_')) {
        text.push(option);
      }
    });
  }

  let displayText = "";
  if (text.length > 1) {
    displayText = text.join(", ");
    if (displayText.length > 15) {
      displayText = displayText.substring(0, 12) + "...";
    }
  } else {
    displayText = text.length === 1 ? text[0] : "-";
  }

  if (onlyText) {
    return displayText;
  }

  $(context)
    .closest(".interface__group")
    .find(".interface__group__head__param")
    .text(displayText);
}

export function interfaceGroupInputsComponent(
  type,
  ranges,
  initValue = false,
  title
) {
  switch (type) {
    case typesInputs.radioModel:
      const radioModelInputs = $(`
                <form class="type_interface_radio-model">
                  <div class="type_interface_radio-model_item option">
                    <input class="type_interface_radio-model_option type_interface_radio-model_option--titan" 
                        type="radio" id="titan" name="fav_language" value="titan">
                    <label class="type_interface_radio-model_label" for="titan">TitanCover™</label>
                  </div>

                  <div class="type_interface_radio-model_item option">
                    <input class="type_interface_radio-model_option type_interface_radio-model_option--lite" 
                        type="radio" id="lite" name="fav_language" value="lite">
                    <label class="type_interface_radio-model_label" for="lite">LiteShade™</label>
                  </div>
                </form>`);

      const activeModelClass = "type_interface_radio-model_item--active";

      //INIT MODEL
      if (!state.model) {
        $("#param-light").show();
        // $('.interface__group').eq(3).hide();
      } else {
        $("#param-light").hide();
        // $('.interface__group').eq(3).show();
      }

      radioModelInputs
        .find('.type_interface_radio-model_item input[type="radio"]')
        .each(function () {
          const radioButton = $(this);
          const labelText = radioButton.next("label").text();

          if (groups[0].param === labelText) {
            radioButton
              .closest(".type_interface_radio-model_item")
              .addClass(activeModelClass);
          }
        });

      //#region HANDLE MODEL
      radioModelInputs
        .find('.type_interface_radio-model_item input[type="radio"]')
        .on("change", function () {
          // CHANGE STATE
          state.model = !state.model;
          state.isRotated = false;

          const parentItem = $(this).closest(
            ".type_interface_radio-model_item"
          );
          const roofGroup = createRoofGroup();
          const roofTypes = $(".interface__group").eq(3);

          if (!state.model) {
            roofTypes.hide();
          } else if (state.model && state.typeLiteShadeRoof === "Screens") {
            roofTypes.show();
          }

          updateRoofInputs(roofGroup);

          updateUIAfterModelChange(parentItem);

          updatePostSize();

          listenerChange();
        });

      //#region ROOF PARAMS
      function createRoofGroup() {
        return {
          title: "Roof",
          param: !state.model ? "Louvered" : state.typeLiteShadeRoof,
          type: !state.model ? typesInputs.range : typesInputs.roofForLite,
          ranges: [
            {
              title: "Rotation",
              min: 0,
              max: 90,
              step: 1,
              thumb: false,
              initialValue: state.currentRotationZ,
              showLabels: true,
              showSwitchAngle: true,
            },
          ],
        };
      }
      //#endregion

      //#region ADD ROOF GROUP
      function updateRoofInputs(roofGroup) {
        const inputsRoof = $($(".interface__group")[2]).find(
          ".interface__group__inputs"
        );
        const newInputs = interfaceGroupInputsComponent(
          roofGroup.type,
          roofGroup.ranges,
          roofGroup.initValuePostSize,
          roofGroup.title
        );

        inputsRoof
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text(roofGroup.param);

        inputsRoof.empty();
        inputsRoof.append(newInputs);
      }
      //#endregion

      //#region UPDATE UI
      function updateUIAfterModelChange(parentItem) {
        groups[0].param = $(parentItem).find("label").text();
        $(parentItem)
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text(groups[0].param);

        radioModelInputs
          .find(".type_interface_radio-model_item")
          .removeClass(activeModelClass);

        parentItem.addClass(activeModelClass);
      }
      //#endregion

      //#region UPDATE POST
      function updatePostSize() {
        const postSizeOptions = $(".type_interface_post-size_item");
        const activeClass = "type_interface_post-size_item--active";
        const param = !state.model ? `8" x 8"` : `4" x 4"`;

        ChangeGlobalMorph("4-8", 0.5);

        postSizeOptions.eq(0).addClass(activeClass);
        postSizeOptions.eq(1).removeClass(activeClass);

        state.initValuePostSize = "6";
        postSizeOptions.eq(1).text(param);

        $(".interface__group")
          .find(".interface__group__head__param")
          .eq(5)
          .text('6" x 6"');

        if (!state.model) {
          $("#param-light").show();
        } else {
          $("#param-light").hide();
        }
      }
      //#endregion
      //#endregion

      return radioModelInputs;

    case typesInputs.selectButton:
      const selectWalls = $(`
              <form class="type_interface_checkbox-wall">
                <div class="type_interface_checkbox-wall_item option" id="back"> 
                  <div class="type_interface_checkbox-wall_item-img type_interface_checkbox-wall_item-img--back"></div>

                  <div class="type_interface_checkbox-wall_bottom">
                    <input class="type_interface_checkbox-wall_option" type="checkbox">
                    <label for="back">Back Wall</label>
                  </div> 
                </div>
           
                <div class="type_interface_checkbox-wall_item option" id="left"> 
                  <div class="type_interface_checkbox-wall_item-img type_interface_checkbox-wall_item-img--left"></div>

                  <div class="type_interface_checkbox-wall_bottom">
                    <input class="type_interface_checkbox-wall_option" type="checkbox">
                    <label for="left">Left Wall</label>
                  </div> 
                </div>
             
                <div class="type_interface_checkbox-wall_item option" id="right"> 
                  <div class="type_interface_checkbox-wall_item-img type_interface_checkbox-wall_item-img--right"></div>

                  <div class="type_interface_checkbox-wall_bottom">
                    <input class="type_interface_checkbox-wall_option" type="checkbox">
                    <label for="right">Right Wall</label>
                  </div> 
                </div>
              </form>
               `);

      const activeWallClass = "type_interface_checkbox-wall_item--active";
      const backWall = selectWalls.find("#back");
      const leftWall = selectWalls.find("#left");
      const rightWall = selectWalls.find("#right");

      function toggleClass(item, settings) {
        if (settings) {
          item.addClass(activeWallClass);
        } else {
          item.removeClass(activeWallClass);
        }
      }

      // INIT BUTTONS WALL
      toggleBackWall(state.backWall);
      toggleLeftWall(state.leftWall);
      toggleRightWall(state.rightWall);

      updateTextParam(state, backWall);

      if (state.backWall) {
        toggleClass(backWall, state.backWall);
      }
      if (state.leftWall) {
        toggleClass(leftWall, state.leftWall);
      }
      if (state.rightWall) {
        toggleClass(rightWall, state.rightWall);
      }

      // HANDLE BUTTONS WALL
      backWall.on("click", function () {
        state.backWall = !state.backWall;
        listenerChange();

        toggleBackWall(state.backWall);
        toggleClass($(this), state.backWall);

        spansScreen
          .filter((span) => span.side === "top")
          .forEach((span) => {
            span.isScreen = false;
            span.isShades = false;

            span.columns &&
              span.columns.forEach((column) => (column.visible = false));

            span.prepareScreens.forEach((data) => {
              data.screen.visible = false;

              data.screen.children.forEach((child) => {
                child.visible = false;
              });
            });

            span.prepareShades.forEach((data) => {
              data.shade.visible = false;

              data.shade.children.forEach((child) => {
                child.visible = false;
              });
            });
          });

        // spansHeaters
        //   .filter((span) => span.side === "top")
        //   .forEach((span, index) => {
        //     span.isHeater = false;

        //     const UFO = modelForExport.children.find(
        //       (group) =>
        //         group.name.includes(`clone_ufo`) &&
        //         group.name.includes(span.side)
        //     );

        //     if (UFO) {
        //       UFO.visible = false;
        //       UFO.children.forEach((child) => {
        //         child.visible = false;
        //       });
        //     }
        //   });

        state.currentActiveSpans = state.currentActiveSpans.filter(
          (id) => !id.includes("top")
        );

        const hasActiveScreens = state.currentActiveSpans.some(span => span.includes("**SC"));
        if (!hasActiveScreens) {
          state.subSystem.delete("Screens");
          const $screenRadio = $('.type_interface_subSystem_option[data-subsystem="screens"]');
          $screenRadio.prop("checked", false)
            .closest('.type_interface_subSystem_item')
            .removeClass('type_interface_subSystem_item--active');

          if (window.screenIcon) window.screenIcon.hide();

          if (window.subSystemHelpers && window.subSystemHelpers.updateTextParam) {
            $screenRadio.closest(".interface__group")
              .find(".interface__group__head__param")
              .text(`${window.subSystemHelpers.updateTextParam(state, $screenRadio[0], true, true, true)}`);
          }
        }

        const hasActiveShades = state.currentActiveSpans.some(span => span.includes("**SH"));
        if (!hasActiveShades) {
          state.subSystem.delete("Shades");
          const $shadesRadio = $('.type_interface_subSystem_option[data-subsystem="shades"]');
          $shadesRadio.prop("checked", false)
            .closest('.type_interface_subSystem_item')
            .removeClass('type_interface_subSystem_item--active');

          if (window.shadesIcon) window.shadesIcon.hide();

          if (window.subSystemHelpers && window.subSystemHelpers.updateTextParam) {
            $shadesRadio.closest(".interface__group")
              .find(".interface__group__head__param")
              .text(`${window.subSystemHelpers.updateTextParam(state, $shadesRadio[0], true, true, true)}`);
          }
        }

        updateTextParam(state, this);
        setAllHotspotsVisibility(false);
      });

      leftWall.on("click", function () {
        state.leftWall = !state.leftWall;
        listenerChange();

        toggleLeftWall(state.leftWall);
        toggleClass($(this), state.leftWall);

        spansScreen
          .filter((span) => span.side === "left")
          .forEach((span) => {
            span.isScreen = false;
            span.isShades = false;

            span.columns &&
              span.columns.forEach((column) => (column.visible = false));

            span.prepareScreensZ.forEach((data) => {
              data.screen.visible = false;

              data.screen.children.forEach((child) => {
                child.visible = false;
              });
            });

            span.prepareShadesZ.forEach((data) => {
              data.shadeZ.visible = false;

              data.shadeZ.children.forEach((child) => {
                child.visible = false;
              });
            });
          });

        state.currentActiveSpans = state.currentActiveSpans.filter(
          (id) => !id.includes("left")
        );

        // spansHeaters
        //   .filter((span) => span.side === "left")
        //   .forEach((span, index) => {
        //     span.isHeater = false;

        //     const UFO = modelForExport.children.find(
        //       (group) =>
        //         group.name.includes(`clone_ufo`) &&
        //         group.name.includes(span.side)
        //     );

        //     if (UFO) {
        //       UFO.visible = false;
        //       UFO.children.forEach((child) => {
        //         child.visible = false;
        //       });
        //     }
        //   });

        const hasActiveScreens = state.currentActiveSpans.some(span => span.includes("**SC"));
        if (!hasActiveScreens) {
          state.subSystem.delete("Screens");
          const $screenRadio = $('.type_interface_subSystem_option[data-subsystem="screens"]');
          $screenRadio.prop("checked", false)
            .closest('.type_interface_subSystem_item')
            .removeClass('type_interface_subSystem_item--active');

          if (window.screenIcon) window.screenIcon.hide();

          if (window.subSystemHelpers && window.subSystemHelpers.updateTextParam) {
            $screenRadio.closest(".interface__group")
              .find(".interface__group__head__param")
              .text(`${window.subSystemHelpers.updateTextParam(state, $screenRadio[0], true, true, true)}`);
          }
        }

        const hasActiveShades = state.currentActiveSpans.some(span => span.includes("**SH"));
        if (!hasActiveShades) {
          state.subSystem.delete("Shades");
          const $shadesRadio = $('.type_interface_subSystem_option[data-subsystem="shades"]');
          $shadesRadio.prop("checked", false)
            .closest('.type_interface_subSystem_item')
            .removeClass('type_interface_subSystem_item--active');

          if (window.shadesIcon) window.shadesIcon.hide();

          if (window.subSystemHelpers && window.subSystemHelpers.updateTextParam) {
            $shadesRadio.closest(".interface__group")
              .find(".interface__group__head__param")
              .text(`${window.subSystemHelpers.updateTextParam(state, $shadesRadio[0], true, true, true)}`);
          }
        }

        updateTextParam(state, this);
        setAllHotspotsVisibility(false);
      });

      rightWall.on("click", function () {
        state.rightWall = !state.rightWall;
        listenerChange();

        toggleRightWall(state.rightWall);
        toggleClass($(this), state.rightWall);

        spansScreen
          .filter((span) => span.side === "right")
          .forEach((span) => {
            span.isScreen = false;
            span.isShades = false;

            span.columns &&
              span.columns.forEach((column) => (column.visible = false));

            span.prepareScreensZ.forEach((data) => {
              data.screen.visible = false;

              data.screen.children.forEach((child) => {
                child.visible = false;
              });
            });

            span.prepareShadesZ.forEach((data) => {
              data.shadeZ.visible = false;

              data.shadeZ.children.forEach((child) => {
                child.visible = false;
              });
            });
          });

        state.currentActiveSpans = state.currentActiveSpans.filter(
          (id) => !id.includes("right")
        );

        // spansHeaters
        //   .filter((span) => span.side === "right")
        //   .forEach((span, index) => {
        //     span.isHeater = false;

        //     const UFO = modelForExport.children.find(
        //       (group) =>
        //         group.name.includes(`clone_ufo`) &&
        //         group.name.includes(span.side)
        //     );

        //     if (UFO) {
        //       UFO.visible = false;
        //       UFO.children.forEach((child) => {
        //         child.visible = false;
        //       });
        //     }
        //   });

        const hasActiveScreens = state.currentActiveSpans.some(span => span.includes("**SC"));
        if (!hasActiveScreens) {
          state.subSystem.delete("Screens");
          const $screenRadio = $('.type_interface_subSystem_option[data-subsystem="screens"]');
          $screenRadio.prop("checked", false)
            .closest('.type_interface_subSystem_item')
            .removeClass('type_interface_subSystem_item--active');

          if (window.screenIcon) window.screenIcon.hide();

          if (window.subSystemHelpers && window.subSystemHelpers.updateTextParam) {
            $screenRadio.closest(".interface__group")
              .find(".interface__group__head__param")
              .text(`${window.subSystemHelpers.updateTextParam(state, $screenRadio[0], true, true, true)}`);
          }
        }

        const hasActiveShades = state.currentActiveSpans.some(span => span.includes("**SH"));
        if (!hasActiveShades) {
          state.subSystem.delete("Shades");
          const $shadesRadio = $('.type_interface_subSystem_option[data-subsystem="shades"]');
          $shadesRadio.prop("checked", false)
            .closest('.type_interface_subSystem_item')
            .removeClass('type_interface_subSystem_item--active');

          if (window.shadesIcon) window.shadesIcon.hide();

          if (window.subSystemHelpers && window.subSystemHelpers.updateTextParam) {
            $shadesRadio.closest(".interface__group")
              .find(".interface__group__head__param")
              .text(`${window.subSystemHelpers.updateTextParam(state, $shadesRadio[0], true, true, true)}`);
          }
        }

        updateTextParam(state, this);
        setAllHotspotsVisibility(false);
      });

      return selectWalls;

    case typesInputs.range:
      let rangesResult = $(``);

      if (ranges.length) {
        ranges.forEach((range) => {
          rangesResult = rangesResult.add(generateRangeHTML(range));
        });
      }

      return rangesResult;

    case typesInputs.postSize:
      const postSizeContent = $(`
              <form class="type_interface_post-size">
                  <div class="type_interface_post-size_item option">
                      <input class="type_interface_post-size_option" type="radio" id="6-6" name="fav_language" value="titan1">
                      <label for="titan1">6" x 6"</label>
                  </div>
             
                  <div class="type_interface_post-size_item option">
                      <input class="type_interface_post-size_option" type="radio" id="8-8" name="fav_language" value="titan2">
                      <label for="titan2">${!state.model ? `8" x 8"` : `4" x 4"`
        }</label>
                 </div>
              </form>
          `);

      const activeClass = "type_interface_post-size_item--active";

      //INIT INPUT
      postSizeContent
        .find(".type_interface_post-size_item")
        .removeClass(activeClass);

      if (
        state.initValuePostSize.includes("8") ||
        state.initValuePostSize.includes("4")
      ) {
        postSizeContent
          .find(".type_interface_post-size_item")
          .eq(1)
          .addClass(activeClass);

        state.initValuePostSize.includes("4") && ChangeGlobalMorph("4-8", 0);
        state.initValuePostSize.includes("8") && ChangeGlobalMorph("4-8", 1);
      } else {
        postSizeContent
          .find(".type_interface_post-size_item")
          .eq(0)
          .addClass(activeClass);
        ChangeGlobalMorph("4-8", 0.5);
      }

      //ADD EVENT
      function updatePostSizeParams(selectedIndex) {
        const paramHead =
          selectedIndex === 0
            ? '6" x 6"'
            : !state.model
              ? `8" x 8"`
              : `4" x 4"`;

        state.initValuePostSize = paramHead;
        const keyShapeValue = selectedIndex === 0 ? 0.5 : !state.model ? 1 : 0;

        const postSizeId = selectedIndex === 0 ? "#6-6" : "#8-8";
        postSizeContent.find(postSizeId).prop("checked", true);

        const $groupHeadParam = $(this)
          .closest(".interface__group")
          .find(".interface__group__head__param");
        $groupHeadParam.text(paramHead);

        if (state.model && selectedIndex === 1) {
          $(this).find("label").text(paramHead);
        }

        ChangeGlobalMorph("4-8", keyShapeValue);

        listenerChange();
      }

      //HANDLE INPUT
      postSizeContent
        .find(".type_interface_post-size_item")
        .on("click", function () {
          $(".type_interface_post-size_item").removeClass(activeClass);

          const selectedIndex = $(this).index();

          $(this).addClass(activeClass);

          updatePostSizeParams.call(this, selectedIndex);
        });

      return postSizeContent;

    case typesInputs.colorsButton:
      const colorButtonContent = $(`
                    <form class="type_interface_colors-buttons">
                        <div class="type_interface_colors-buttons_item option">
                            <label class="type_interface_colors-buttons_label">
                                <div class="image-container">
                                    <img src="./public/img/colors/Rectangle-1.svg" alt="Textured Black" class="color-image">
                                </div>
                                <span class="color-name">Textured Black</span>
                                <input class="type_interface_colors-buttons_option" type="radio" id="TexturedBlack" name="fav_language" value="Textured Black">
                            </label>
                        </div>
                        
                        <div class="type_interface_colors-buttons_item option">
                            <label class="type_interface_colors-buttons_label">
                                <div class="image-container">
                                    <img src="./public/img/colors/Rectangle-2.svg" alt="Textured White" class="color-image">
                                </div>
                                <span class="color-name">Textured White</span>
                                <input class="type_interface_colors-buttons_option" type="radio" id="TexturedWhite" name="fav_language" value="Textured White">
                            </label>
                        </div>
                
                        <div class="type_interface_colors-buttons_item option">
                            <label class="type_interface_colors-buttons_label">
                                <div class="image-container">
                                    <img src="./public/img/colors/Rectangle-3.svg" alt="Industrial Grey" class="color-image">
                                </div>
                                <span class="color-name">Industrial Grey</span>
                                <input class="type_interface_colors-buttons_option" type="radio" id="IndustrialGrey" name="fav_language" value="Industrial Grey">
                            </label>
                        </div>
                
                        <div class="type_interface_colors-buttons_item option">
                            <label class="type_interface_colors-buttons_label">
                                <div class="image-container">
                                    <img src="./public/img/colors/Rectangle-4.svg" alt="Charcoal" class="color-image">
                                </div>
                                <span class="color-name">Charcoal</span>
                                <input class="type_interface_colors-buttons_option" type="radio" id="Charcoal" name="fav_language" value="Charcoal">
                            </label>
                        </div>
                
                        <div class="type_interface_colors-buttons_item option">
                            <label class="type_interface_colors-buttons_label">
                                <div class="image-container">
                                    <img src="./public/img/colors/Rectangle-5.svg" alt="C34 Bronze" class="color-image">
                                </div>
                                <span class="color-name">C34 Bronze</span>
                                <input class="type_interface_colors-buttons_option" type="radio" id="C34Bronze" name="fav_language" value="C34 Bronze">
                            </label>
                        </div>
                
                        <div class="type_interface_colors-buttons_item option">
                            <label class="type_interface_colors-buttons_label">
                                <div class="image-container">
                                    <img src="./public/img/colors/Rectangle-6.svg" alt="Anodized Bronze" class="color-image">
                                </div>
                                <span class="color-name">Anodized Bronze</span>
                                <input class="type_interface_colors-buttons_option" type="radio" id="AnodizedBronze" name="fav_language" value="Anodized Bronze">
                            </label>
                        </div>
                
                        <div class="type_interface_colors-buttons_item option">
                            <label class="type_interface_colors-buttons_label">
                                <div class="image-container">
                                    <img src="./public/img/colors/Rectangle-7.svg" alt="Expresso" class="color-image">
                                </div>
                                <span class="color-name">Expresso</span>
                                <input class="type_interface_colors-buttons_option" type="radio" id="Expresso" name="fav_language" value="Expresso">
                            </label>
                        </div>
                
                        <div class="type_interface_colors-buttons_item option">
                            <label class="type_interface_colors-buttons_label">
                                <div class="image-container">
                                    <img src="./public/img/colors/Rectangle-8.svg" alt="Gold" class="color-image">
                                </div>
                                <span class="color-name">Gold</span>
                                <input class="type_interface_colors-buttons_option" type="radio" id="Gold" name="fav_language" value="Gold">
                            </label>
                        </div>
                    </form>
                `);

      const activeColorClass = "type_interface_colors-buttons_item--active";

      //LOGIC FOR FRAME COLOR
      if (title === "Frame Color") {
        const mesh = GetMesh("header");

        //INIT INPUT
        colorButtonContent.find('input[type="radio"]').each(function () {
          const inputValue = $(this).val();
          if (state.colorBody === inputValue) {
            $(this)
              .closest(".type_interface_colors-buttons_item")
              .addClass(activeColorClass);
            $(this).prop("checked", true);
          }
          if (mesh && mesh.material) {
            mesh.material.color.set(colors[state.colorBody]);
          }
        });

        //HANDLE INPUTS
        colorButtonContent
          .find('input[type="radio"]')
          .on("change", function () {
            const newColorValue = $(this).val();
            state.colorBody = newColorValue;
            $(this)
              .closest(".type_interface_colors-buttons_item")
              .addClass(activeColorClass);
            $(this)
              .closest(".interface__group")
              .find(".interface__group__head__param")
              .text(`${state.colorBody}`);

            if (mesh && mesh.material) {
              if (state.colorBody === "Gold") {
                mesh.material.color.set("#C5A052");
                mesh.material.metalness = 0.85;
                mesh.material.roughness = 0.45;

                mesh.material.map = createGoldNoiseTexture();
              } else {
                mesh.material.color.set(colors[state.colorBody]);
                mesh.material.metalness = 0.0;
                mesh.material.roughness = 1.0;
                mesh.material.map = null;
              }

              mesh.material.needsUpdate = true;
            }

            modelForExport.traverse((child) => {
              // Skip screen columns
              if (child.userData && child.userData.isScreenColumn) {
                return;
              }

              if (child.isMesh && child.material && child.name.includes("posr")) {
                if (child.material.color) {
                  child.material.color.set(colors[state.colorBody]);
                }
              }
            });
          });
      }

      //LOGIC FOR ROOF COLOR
      if (title === "Roof Color") {
        const mesh = GetMesh("louver_Y");
        const screen = GetMesh("Plane001_1");
        const frameSreens = GetMesh("Plane001");

        //INIT INPUT
        colorButtonContent.find('input[type="radio"]').each(function () {
          const inputValue = $(this).val();
          if (state.colorRoof === inputValue) {
            $(this)
              .closest(".type_interface_colors-buttons_item")
              .addClass(activeColorClass);
            $(this).prop("checked", true);
          }

          if (mesh && mesh.material) {
            mesh.material.color.set(colors[state.colorRoof]);
            screen.material.color.set(colors[state.colorRoof]);
            frameSreens.material.color.set(colors[state.colorRoof]);
          }
        });

        //HANDLE INPUTS
        colorButtonContent
          .find('input[type="radio"]')
          .on("change", function () {
            const newColorValue = $(this).val();

            state.colorRoof = newColorValue;

            $(this)
              .closest(".type_interface_colors-buttons_item")
              .addClass(activeColorClass);

            $(this)
              .closest(".type_interface_colors-buttons")
              .find(".type_interface_colors-buttons_item")
              .not($(this).closest(".type_interface_colors-buttons_item"))
              .removeClass(activeColorClass);

            $(this)
              .closest(".interface__group")
              .find(".interface__group__head__param")
              .text(`${state.colorRoof}`);

            if (mesh && mesh.material) {
              mesh.material.color.set(colors[state.colorRoof]);
              screen.material.color.set(colors[state.colorRoof]);
              frameSreens.material.color.set(colors[state.colorRoof]);
            }
          });
      }

      return colorButtonContent;

    case typesInputs.electronic:
      let pendingElectro = null;
      let hasPlacedHeater = false;
      const electronicContent = $(`
                <form class="type_interface_electronic">
                  <div class="type_interface_electronic_item option">
                    <label class="type_interface_electronic_label">
                       <div class="image-container">
                           <img src="./public/img/electro/Rectangle-2.svg" alt="Textured Black" class="color-image">
                       </div>
                       
                       <span class="electronic-name">Recessed Lighting</span>
                       <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="Recessed Lighting">
                    </label>
                  </div>

                  <div class="type_interface_electronic_item option" id="param-light">
                    <label class="type_interface_electronic_label">
                       <div class="image-container">
                           <img src="./public/img/electro/Rectangle-1.svg" alt="Textured Black" class="color-image">
                       </div>
                       
                       <span class="electronic-name">Perimeter Lights</span>
                       <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="Perimeter Lights">
                    </label>
                  </div>

                  <div class="type_interface_electronic_item option">
                    <label class="type_interface_electronic_label">
                       <div class="image-container">
                           <img src="./public/img/electro/Rectangle-4.svg" alt="Textured Black" class="color-image">
                       </div>
                       
                       <span class="electronic-name">Fans</span>
                       <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="Fans">
                    </label>
                  </div>

                  <div class="type_interface_electronic_item option">
                    <label class="type_interface_electronic_label">
                       <div class="image-container">
                           <img src="./public/img/electro/Rectangle-3.svg" alt="Textured Black" class="color-image">
                       </div>
                       
                       <span class="electronic-name">Heaters</span>
                       <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="Heaters">
                    </label>
                  </div>
                </form>
            `);

      const activeStyle = "type_interface_electronic_item--active";
      const portalLight = $(".portal-light");
      const portalHeaters = $(".portal-heaters");
      const sunIcon = $("#light");
      const heatersIcon = $("#heaters");
      const paramLight = electronicContent.find("#param-light");

      const closeButtonLight = $(".portal-light__close");
      const closeButtonHeaters = $(".portal-heaters__close");
      const closeButtonScreenElectro = $(".portal-screen__close");

      // INIT INPUT
      electronicContent.find('input[type="radio"]').each(function () {
        const $currentInput = $(this);
        const inputValue = $currentInput.val();
        !state.model ? paramLight.show() : paramLight.hide();
        if (state.electro.has(inputValue)) {
          state.electro.add(inputValue);
          $currentInput.prop("checked", true);
          $currentInput
            .closest(".type_interface_electronic_item")
            .addClass(activeStyle);
          switch (inputValue) {
            case "Recessed Lighting":
              state.portalOption = typePortalOption.light;
              sunIcon.show();
              portalLight.hide();
              break;
            case "Heaters":
              state.portalOption = typePortalOption.heaters;
              heatersIcon.show();
              portalHeaters.hide();
              break;
          }
        }
        updateTextParam(state, this, true);
      });

      setTimeout(() => {
        listenerChange();
      }, 100);

      electronicContent.find('input[type="radio"]').on("click", function (event) {
        event.stopPropagation();

        const $currentInput = $(this);
        const inputValue = $currentInput.val();

        if (state.electro.has(inputValue)) {
          state.electro.delete(inputValue);
          $currentInput.prop("checked", false);
          $currentInput
            .closest(".type_interface_electronic_item")
            .removeClass(activeStyle);

          switch (inputValue) {
            case "Recessed Lighting":
              state.portalOption = "";
              sunIcon.hide();
              portalLight.hide();
              closeButtonLight.trigger("click");
              break;

            case "Heaters":
              state.currentActiveSpans = state.currentActiveSpans.filter(
                spanId => !spanId.includes("heater")
              );

              pendingElectro = null;
              hasPlacedHeater = false;

              state.portalOption = "";
              heatersIcon.hide();
              portalHeaters.hide();
              closeButtonHeaters.trigger("click");
              setAllHotspotsVisibility(false);

              console.log("After heater deactivate, currentActiveSpans:", state.currentActiveSpans);
              break;
          }
        } else {
          // CHECKING
          state.electro.add(inputValue);

          switch (inputValue) {
            case "Recessed Lighting":
              sunIcon.show();
              sunIcon.trigger("click");
              break;

            case "Heaters":
              pendingElectro = "Heaters";
              hasPlacedHeater = false;

              heatersIcon.show();
              heatersIcon.trigger("click");
              break;
          }

          $currentInput.prop("checked", true);
          $currentInput
            .closest(".type_interface_electronic_item")
            .addClass(activeStyle);
        }

        updateTextParam(state, this, true);
        listenerChange();
      });

      function checkAndRevertPendingHeater() {
        if (pendingElectro !== "Heaters" || hasPlacedHeater) return;

        console.log("No heater placed, reverting");

        const $checkbox = electronicContent.find('input[value="Heaters"]');
        $checkbox.prop("checked", false);
        $checkbox.closest(".type_interface_electronic_item").removeClass(activeStyle);

        state.electro.delete("Heaters");
        state.portalOption = "";

        heatersIcon.hide();
        portalHeaters.hide();
        closeButtonHeaters.trigger("click");

        setAllHotspotsVisibility(false);

        pendingElectro = null;
        hasPlacedHeater = false;

        updateTextParam(state, $checkbox[0], true);
      }

      // Document click listener with delay
      $(document).on("click.heaterCheck", function (event) {
        const $target = $(event.target);

        if ($target.closest(".type_interface_electronic").length ||
          $target.closest(".hotspot").length ||
          $target.closest(".portal-heaters").length ||
          $target.closest("#heaters").length) {
          return;
        }

        setTimeout(() => {
          checkAndRevertPendingHeater();
        }, 50);
      });

      window.heaterHelpers = {
        setHeaterPlacementFlag: () => {
          hasPlacedHeater = true;
          console.log("Heater placed, flag set");
        }
      };

      return electronicContent;

    case typesInputs.subSystem:
      let pendingSubSystem = null;
      let hasPlacedElement = false;

      const subSystemContent = $(`
    <form class="type_interface_subSystem" id="last-group">
      ${Object.entries(subSystemConfig).map(([key, config]) => `
        <div class="type_interface_subSystem_item option" data-subsystem="${key}">
          <label class="type_interface_subSystem_label">
            <div class="image-container">
              <img src="${config.image}" alt="${config.label}" class="color-image">
            </div>
            <span class="subSystem-name">${config.label}</span>
            <input class="type_interface_subSystem_option" 
                   type="radio" 
                   name="subsystem" 
                   value="${config.type}" 
                   data-subsystem="${key}">
          </label>
        </div>
      `).join('')}
    </form>
  `);

      const activeStyleSubSystem = "type_interface_subSystem_item--active";

      function getSubSystemElement(subsystemKey) {
        return $(`.type_interface_subSystem_item[data-subsystem="${subsystemKey}"]`);
      }

      function activateSubSystem(subsystemKey) {
        const config = subSystemConfig[subsystemKey];
        if (!config) return;

        state.subSystem.add(config.type);
        pendingSubSystem = subsystemKey;
        hasPlacedElement = false;

        if (subsystemKey === 'screens') {
          if (window.screenIcon && window.screenIcon.length > 0) {
            window.screenIcon.show();
            window.screenIcon.trigger("click");
          }
        } else if (subsystemKey === 'shades') {
          if (window.shadesIcon && window.shadesIcon.length > 0) {
            window.shadesIcon.show();
            window.shadesIcon.trigger("click");
          }
        }

        getSubSystemElement(subsystemKey).addClass(activeStyleSubSystem);
      }

      function deactivateSubSystem(subsystemKey) {
        const config = subSystemConfig[subsystemKey];
        if (!config) return;

        state.subSystem.delete(config.type);
        pendingSubSystem = null;
        hasPlacedElement = false;

        if (subsystemKey === 'screens') {
          state.currentActiveSpans = state.currentActiveSpans.filter(
            spanId => !spanId.includes("**SC")
          );

          if (window.screenIcon && window.screenIcon.length > 0) {
            window.screenIcon.hide();
          }
          if (window.closeButtonScreen && window.closeButtonScreen.length > 0) {
            window.closeButtonScreen.trigger("click");
          }
          resetSpansActiveScreen();
          spansScreen.forEach((span) => {
            span.isScreen = false;
            span.prepareScreens?.forEach((data) => {
              data.screen.visible = false;
              data.screen.children.forEach((child) => {
                child.visible = false;
              });
            });
            span.prepareScreensZ?.forEach((data) => {
              data.screen.visible = false;
              data.screen.children.forEach((child) => {
                child.visible = false;
              });
            });
          });
        } else if (subsystemKey === 'shades') {
          state.currentActiveSpans = state.currentActiveSpans.filter(
            spanId => !spanId.includes("**SH")
          );

          if (window.shadesIcon && window.shadesIcon.length > 0) {
            window.shadesIcon.hide();
          }
          if (window.closeButtonShades && window.closeButtonShades.length > 0) {
            window.closeButtonShades.trigger("click");
          }
          resetSpansActiveShades();
          spansScreen.forEach((span) => {
            span.isShades = false;
            span.prepareShades?.forEach((data) => {
              data.shade.visible = false;
              data.shade.children.forEach((child) => {
                child.visible = false;
              });
            });
            span.prepareShadesZ?.forEach((data) => {
              data.shadeZ.visible = false;
              data.shadeZ.children.forEach((child) => {
                child.visible = false;
              });
            });
          });
        }

        getSubSystemElement(subsystemKey).removeClass(activeStyleSubSystem);

        console.log("After deactivate, currentActiveSpans:", state.currentActiveSpans);
      }


      function checkAndRevertPending() {
        if (pendingSubSystem && !hasPlacedElement) {

          const $checkbox = $(`.type_interface_subSystem_option[data-subsystem="${pendingSubSystem}"]`);
          $checkbox.prop("checked", false);

          deactivateSubSystem(pendingSubSystem);

          const $group = $checkbox.closest(".interface__group");
          $group.find(".interface__group__head__param")
            .text(`${updateTextParam(state, $checkbox[0], true, true, true)}`);
        }
      }

      $(document).on("click", function (event) {
        const $target = $(event.target);

        if (!$target.closest("#last-group").length &&
          !$target.closest(".hotspot").length) {
          checkAndRevertPending();
        }
      });

      subSystemContent.find('input[type="radio"]').on("click", function () {
        event.stopPropagation();

        const $currentInput = $(this);
        const inputValue = $currentInput.val();
        const subsystemKey = $currentInput.data('subsystem');

        if (state.subSystem.has(inputValue)) {
          $currentInput.prop("checked", false);
          deactivateSubSystem(subsystemKey);
        } else {

          $currentInput.prop("checked", true);
          activateSubSystem(subsystemKey);
        }

        listenerChange();
        $(this)
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text(`${updateTextParam(state, this, true, true, true)}`);
      });

      window.subSystemHelpers = {
        getSubSystemElement,
        activateSubSystem,
        deactivateSubSystem,
        activeStyleSubSystem,
        updateTextParam,
        checkAndRevertPending,
        setPlacementFlag: () => { hasPlacedElement = true; }
      };


      setTimeout(() => {
        Object.entries(subSystemConfig).forEach(([key, config]) => {
          if (state.subSystem.has(config.type)) {
            $(`.type_interface_subSystem_option[data-subsystem="${key}"]`).prop("checked", true);
            getSubSystemElement(key).addClass(activeStyleSubSystem);
          }
        });
      }, 100);

      return subSystemContent;

    case typesInputs.roofForLite:
      const roofContent = $(`
                <form class="type_interface_electronic">
                  <div class="type_interface_electronic_item option">
                    <label class="type_interface_electronic_label">
                       <div class="image-container">
                           <img src="./public/img/sletted.png" alt="Screens" class="color-image">
                       </div>
                       
                       <span class="electronic-name">Slatted</span>
                       <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="Slatted">
                    </label>
                  </div>

                  <div class="type_interface_electronic_item option">
                    <label class="type_interface_electronic_label">
                       <div class="image-container">
                           <img src="./public/img/screen-roof.png" alt="Textured Black" class="color-image">
                       </div>
                       
                       <span class="electronic-name">Screens</span>
                       <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="Screens">
                    </label>
                  </div>
                </form>
                `);

      const activeStyleRoof = "type_interface_electronic_item--active";

      // INIT INPUT
      roofContent.find('input[type="radio"]').each(function () {
        const inputValue = $(this).val();

        if (state.typeLiteShadeRoof === inputValue) {
          $(this)
            .closest(".type_interface_electronic_item")
            .addClass(activeStyleRoof);
          $(this).prop("checked", true);
        }
      });

      // HANDLE INPUTS
      roofContent.find('input[type="radio"]').on("click", function () {
        const inputValue = $(this).val();
        state.typeLiteShadeRoof = inputValue;

        // CURRENT OPTION
        $(this).prop("checked", true);
        $(this)
          .closest(".type_interface_electronic_item")
          .addClass(activeStyleRoof);

        // ALL OPTION
        $(this)
          .closest(".type_interface_electronic")
          .find(".type_interface_electronic_item")
          .not($(this).closest(".type_interface_electronic_item"))
          .removeClass(activeStyleRoof);

        // UPDATE TEXT
        $(this)
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text(`${state.typeLiteShadeRoof}`);

        listenerChange();
      });

      //#region SCREEN BUTTON HANDLE
      roofContent
        .find(".type_interface_electronic_item")
        .eq(1)
        .on("click", () => {
          const roofTypes = $(".interface__group").eq(3);

          roofTypes.show();
          listenerChange();
        });
      //#endregion

      //#region SLATTED HANDLE
      roofContent
        .find(".type_interface_electronic_item")
        .eq(0)
        .on("click", () => {
          const roofTypes = $(".interface__group").eq(3);

          roofTypes.hide();
          listenerChange();
        });
      //#endregion

      return roofContent;

    case typesInputs.roofTypes:
      const roofButtonContent = $(`
            <form class="type_interface_roof-buttons">
                <div class="type_interface_roof-buttons_item option">
                    <label class="type_interface_roof-buttons_label">
                        <div class="image-container">
                            <img src="./public/img/roof-types-icon/branch-1.svg" alt="Branch" class="roof-image">
                        </div>

                        <span class="roof-name">Branch</span>
                        <input class="type_interface_roof-buttons_option" type="radio" id="Branch" name="fav_roof" value="Branch">
                    </label>
                </div>
        
                <div class="type_interface_roof-buttons_item option">
                    <label class="type_interface_roof-buttons_label">
                        <div class="image-container">
                            <img src="./public/img/roof-types-icon/breeze.svg" alt="Breeze" class="roof-image">
                        </div>

                        <span class="roof-name">Breeze</span>
                        <input class="type_interface_roof-buttons_option" type="radio" id="Breeze" name="fav_roof" value="Breeze">
                    </label>
                </div>
        
                <div class="type_interface_roof-buttons_item option">
                    <label class="type_interface_roof-buttons_label">
                        <div class="image-container">
                            <img src="./public/img/roof-types-icon/dash.svg" alt="Dash" class="roof-image">
                        </div>

                        <span class="roof-name">Dash</span>
                        <input class="type_interface_roof-buttons_option" type="radio" id="Dash" name="fav_roof" value="Dash">
                    </label>
                </div>
        
                <div class="type_interface_roof-buttons_item option">
                    <label class="type_interface_roof-buttons_label">
                        <div class="image-container">
                            <img src="./public/img/roof-types-icon/hexx.svg" alt="Hexx" class="roof-image">
                        </div>

                        <span class="roof-name">Hexx</span>
                        <input class="type_interface_roof-buttons_option" type="radio" id="Hexx" name="fav_roof" value="Hexx">
                    </label>
                </div>
        
                <div class="type_interface_roof-buttons_item option">
                    <label class="type_interface_roof-buttons_label">
                        <div class="image-container">
                            <img src="./public/img/roof-types-icon/horizon.svg" alt="Horizon" class="roof-image">
                        </div>

                        <span class="roof-name">Horizon</span>
                        <input class="type_interface_roof-buttons_option" type="radio" id="Horizon" name="fav_roof" value="Horizon">
                    </label>
                </div>
        
                <div class="type_interface_roof-buttons_item option">
                    <label class="type_interface_roof-buttons_label">
                        <div class="image-container">
                            <img src="./public/img/roof-types-icon/maui.svg" alt="Maui" class="roof-image">
                        </div>

                        <span class="roof-name">Maui</span>
                        <input class="type_interface_roof-buttons_option" type="radio" id="Maui" name="fav_roof" value="Maui">
                    </label>
                </div>
        
                <div class="type_interface_roof-buttons_item option">
                    <label class="type_interface_roof-buttons_label">
                        <div class="image-container">
                            <img src="./public/img/roof-types-icon/moderna.svg" alt="Moderna" class="roof-image">
                        </div>

                        <span class="roof-name">Moderna</span>
                        <input class="type_interface_roof-buttons_option" type="radio" id="Moderna" name="fav_roof" value="Moderna">
                    </label>
                </div>
        
                <div class="type_interface_roof-buttons_item option">
                    <label class="type_interface_roof-buttons_label">
                        <div class="image-container">
                            <img src="./public/img/roof-types-icon/rain.svg" alt="Rain" class="roof-image">
                        </div>

                        <span class="roof-name">Rain</span>
                        <input class="type_interface_roof-buttons_option" type="radio" id="Rain" name="fav_roof" value="Rain">
                    </label>
                </div>

                <div class="type_interface_roof-buttons_item option">
                    <label class="type_interface_roof-buttons_label">
                        <div class="image-container">
                            <img src="./public/img/roof-types-icon/river-rock.svg" alt="River Rock" class="roof-image">
                        </div>

                        <span class="roof-name">River Rock</span>
                        <input class="type_interface_roof-buttons_option" type="radio" id="River Rock" name="fav_roof" value="River Rock">
                    </label>
                </div>

                <div class="type_interface_roof-buttons_item option">
                    <label class="type_interface_roof-buttons_label">
                        <div class="image-container">
                            <img src="./public/img/roof-types-icon/solid.svg" alt="Solid" class="roof-image">
                        </div>

                        <span class="roof-name">Solid</span>
                        <input class="type_interface_roof-buttons_option" type="radio" id="Solid" name="fav_roof" value="Solid">
                    </label>
                </div>
            </form>
        `);
      const activeClassRoof = "type_interface_roof-buttons_item--active";
      const inputButtons = roofButtonContent.find(
        ".type_interface_roof-buttons_item"
      );

      function initializeActiveClass() {
        const selectedValue = state.patternScreenRoof;

        if (selectedValue) {
          const selectedButton = inputButtons.filter(function () {
            return $(this).find("input").val() === selectedValue;
          });

          if (selectedButton.length > 0) {
            selectedButton.addClass(activeClassRoof);
          }
        }
      }

      initializeActiveClass();

      //#region HANDLE
      inputButtons.on("click", function () {
        state.patternScreenRoof = $(this).find("input").val();

        inputButtons.removeClass(activeClassRoof);

        $(this).addClass(activeClassRoof);

        changeTextureTop();
        $(this)
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text(`${state.patternScreenRoof}`);
      });
      //#endregion

      return roofButtonContent;

    default:
      return `< div > NON HTML</div > `;
  }
}
